enum UserTechAssisTrackingPerm {
    No = 0,
    Yes = 1,
    YesExclusive = 2
}

export default UserTechAssisTrackingPerm;